import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LocaleLookupModel } from 'app/generated/backend/localization/api/locale-lookup-model';

@Injectable()
export class LocaleLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<LocaleLookupModel[]>> {
		return this.http.get<JsonResourceResponse<LocaleLookupModel[]>>('api/v1/localization/locale/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		LocaleLookupHandlerService
	]
})
export class LocaleLookupHandlerModule { }
